/**********************************************************************************************************************/
/* FILE: display-fullmap/hafas_webapp_subscriptions_print.js                                                          */
/**********************************************************************************************************************/
/* Subscriptions PRINT */

HafasWebapp.prototype.subscriptions.PRINT = function (_me) {
  // PRINT-Events ------------------------------------------------------------------------------------------------------

  // tp
  Hafas.ps.sub('/PRINT/tp/', Hafas.bind(_me.Controller.PRINT.tp.initPrintview, _me));
  Hafas.ps.sub('/PRINT/tp/overview', Hafas.bind(function() {
    Hafas.ps.pub('/PRINT/tp/',[{origin:'overview'}]);
  }, _me));


  // tp - configurator
  Hafas.ps.sub('/PRINT/tp/configurator', Hafas.bind(_me.Controller.PRINT.tp, _me));

  // jt - error overview
  Hafas.ps.sub('/PRINT/jt/errorOverview', Hafas.bind(_me.Controller.PRINT.jt.errorOverview, _me));

  // sq - druckansicht
  Hafas.ps.sub('/PRINT/sq/printview', Hafas.bind(_me.Controller.PRINT.sq.init, _me));

  // timetable - alle Tabellen
  Hafas.ps.sub('/PRINT/timetable/printview', Hafas.bind(_me.Controller.PRINT.timetable.printTables, _me));
};
